var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "row info--timeline d-flex align-items-center justify-content-center pb-16 py-lg-30"
    },
    [
      _c(
        "div",
        {
          staticClass:
            "d-block d-lg-none timeline-bar animation-class--mobile-timeline-bar"
        },
        [
          _c("div", { staticClass: "overflow-bar" }, [
            _vm.displayedEvents[8] && _vm.displayedEvents[8].year
              ? _c("span", { staticClass: "timeline-year previous-year" }, [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.displayedEvents[8].year) +
                      "\n\t\t\t"
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.displayedEvents[0] && _vm.displayedEvents[0].year
              ? _c("span", { staticClass: "timeline-year active-year" }, [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.displayedEvents[0].year) +
                      "\n\t\t\t"
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.displayedEvents[1] && _vm.displayedEvents[1].year
              ? _c("span", { staticClass: "timeline-year next-year" }, [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.displayedEvents[1].year) +
                      "\n\t\t\t"
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.displayedEvents[2] && _vm.displayedEvents[2].year
              ? _c("span", { staticClass: "timeline-year" }, [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.displayedEvents[2].year) +
                      "\n\t\t\t"
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.displayedEvents[3] && _vm.displayedEvents[3].year
              ? _c("span", { staticClass: "timeline-year" }, [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.displayedEvents[3].year) +
                      "\n\t\t\t"
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.displayedEvents[4] && _vm.displayedEvents[4].year
              ? _c("span", { staticClass: "timeline-year" }, [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.displayedEvents[4].year) +
                      "\n\t\t\t"
                  )
                ])
              : _vm._e()
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "image px-0 pr-md-4 pl-md-0" }, [
        _c("div", { staticClass: "position-relative h-100" }, [
          _c("div", {
            staticClass: "curtain--slide-to-left animation-class--curtain"
          }),
          _vm._v(" "),
          _c("div", {
            staticClass:
              "bg-image bg-cover bg-position-center animation-class--image",
            style:
              "background-image: url(" + _vm.displayedEvents[0].image + ");"
          }),
          _vm._v(" "),
          _vm.events.length > 0
            ? _c(
                "button",
                {
                  staticClass:
                    "timeline-arrow prevYear d-lg-none animation-class--mobile-prev-year",
                  on: {
                    click: function($event) {
                      return _vm.togglePrev()
                    }
                  }
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "18",
                        height: "18",
                        viewBox: "0 0 48 48"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          fill: "none",
                          "fill-rule": "nonzero",
                          stroke: "#B59D6B",
                          d: "M32 8L16 24l16 16"
                        }
                      })
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.events.length > 0
            ? _c(
                "button",
                {
                  staticClass:
                    "timeline-arrow nextYear d-lg-none animation-class--mobile-next-year",
                  on: {
                    click: function($event) {
                      return _vm.toggleNext()
                    }
                  }
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "18",
                        height: "18",
                        viewBox: "0 0 48 48"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          fill: "none",
                          "fill-rule": "nonzero",
                          stroke: "#B59D6B",
                          d: "M16 8l16 16-16 16"
                        }
                      })
                    ]
                  )
                ]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content pt-10 pt-lg-0" }, [
        _c("div", { staticClass: "text" }, [
          _c(
            "div",
            {
              staticClass: "title-line-1 animation-class--title",
              staticStyle: { visibility: "inherit" }
            },
            [
              _c("span", { staticClass: "h2 text-uppercase" }, [
                _vm._v(_vm._s(_vm.displayedEvents[0].title))
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "paragraph-container mt-6 animation-class--content",
            staticStyle: { visibility: "inherit" },
            domProps: { innerHTML: _vm._s(_vm.displayedEvents[0].content) }
          })
        ])
      ]),
      _vm._v(" "),
      _vm.events
        ? _c(
            "div",
            {
              staticClass:
                "d-none d-lg-block timeline-wheel position-relative overflow-x-hidden"
            },
            [
              _vm.displayedEvents[5] && _vm.displayedEvents[5].year
                ? _c("span", { staticClass: "timeline-year year-0" }, [
                    _vm._v(
                      "\n\t\t\t" +
                        _vm._s(_vm.displayedEvents[5].year) +
                        "\n\t\t"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.displayedEvents[6] && _vm.displayedEvents[6].year
                ? _c("span", { staticClass: "timeline-year year-1" }, [
                    _vm._v(
                      "\n\t\t\t" +
                        _vm._s(_vm.displayedEvents[6].year) +
                        "\n\t\t"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.displayedEvents[7] && _vm.displayedEvents[7].year
                ? _c("span", { staticClass: "timeline-year year-2" }, [
                    _vm._v(
                      "\n\t\t\t" +
                        _vm._s(_vm.displayedEvents[7].year) +
                        "\n\t\t"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.displayedEvents[8] && _vm.displayedEvents[8].year
                ? _c("span", { staticClass: "timeline-year year-3" }, [
                    _vm._v(
                      "\n\t\t\t" +
                        _vm._s(_vm.displayedEvents[8].year) +
                        "\n\t\t"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.displayedEvents[0] && _vm.displayedEvents[0].year
                ? _c("span", { staticClass: "timeline-year active-year" }, [
                    _vm._v(
                      "\n\t\t\t" +
                        _vm._s(_vm.displayedEvents[0].year) +
                        "\n\t\t"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.displayedEvents[1] && _vm.displayedEvents[1].year
                ? _c("span", { staticClass: "timeline-year year-4" }, [
                    _vm._v(
                      "\n\t\t\t" +
                        _vm._s(_vm.displayedEvents[1].year) +
                        "\n\t\t"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.displayedEvents[2] && _vm.displayedEvents[2].year
                ? _c("span", { staticClass: "timeline-year year-5" }, [
                    _vm._v(
                      "\n\t\t\t" +
                        _vm._s(_vm.displayedEvents[2].year) +
                        "\n\t\t"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.displayedEvents[3] && _vm.displayedEvents[3].year
                ? _c("span", { staticClass: "timeline-year year-6" }, [
                    _vm._v(
                      "\n\t\t\t" +
                        _vm._s(_vm.displayedEvents[3].year) +
                        "\n\t\t"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.displayedEvents[4] && _vm.displayedEvents[4].year
                ? _c("span", { staticClass: "timeline-year year-7" }, [
                    _vm._v(
                      "\n\t\t\t" +
                        _vm._s(_vm.displayedEvents[4].year) +
                        "\n\t\t"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.events.length > 0
                ? _c(
                    "button",
                    {
                      staticClass: "timeline-arrow nextYear",
                      on: {
                        click: function($event) {
                          return _vm.toggleNext()
                        }
                      }
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "48",
                            height: "48",
                            viewBox: "0 0 48 48"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              fill: "none",
                              "fill-rule": "nonzero",
                              stroke: "#B59D6B",
                              d: "M8 32l16-16 16 16"
                            }
                          })
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.events.length > 0
                ? _c(
                    "button",
                    {
                      staticClass: "timeline-arrow prevYear",
                      on: {
                        click: function($event) {
                          return _vm.togglePrev()
                        }
                      }
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "48",
                            height: "48",
                            viewBox: "0 0 48 48"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              fill: "none",
                              "fill-rule": "nonzero",
                              stroke: "#B59D6B",
                              d: "M8 16l16 16 16-16"
                            }
                          })
                        ]
                      )
                    ]
                  )
                : _vm._e()
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/arthur.cruz/BRNDWGN/Projects/corinthia/web/app/themes/corinthia/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/arthur.cruz/BRNDWGN/Projects/corinthia/web/app/themes/corinthia/node_modules/vue-loader/lib?{}!./scripts/vue/timeline.vue?vue&type=template&id=dd844f56&
// module id = 65
// module chunks = 0